import { RootState } from '../index';

const getManagerPermissions = (state: RootState) => state.settingsReducer.managerPermissions;

const getEmployeePermissions = (state: RootState) => state.settingsReducer.employeePermissions;

const getIsOpenIntegrationNav = (state: RootState) => state.settingsReducer.isOpenIntegrationNav;

const getDorIntegration = (state: RootState) => state.settingsReducer.dorIntegration;

const getDorLocations = (state: RootState) => state.settingsReducer.dorLocations;

const getIsOpenDorDialog = (state: RootState) => state.settingsReducer.isOpenDorDialog;

const getIntegrations = (state: RootState) => state.settingsReducer.integrations;

export {
  getManagerPermissions,
  getEmployeePermissions,
  getIsOpenIntegrationNav,
  getDorIntegration,
  getDorLocations,
  getIsOpenDorDialog,
  getIntegrations,
};
